export const footerContent = {
  sage: {
    title:
      'Equal Housing Opportunity | Forward Home Lending, LLC dba Sage Mortgage NMLS ID# 1374724',
    copyright: `Copyright © ${new Date().getFullYear()} Sage Mortgage, All rights reserved. Not available in all states. | `,
  },
  interest: {
    title:
      'Equal Housing Opportunity Lender | Interest Mortgage, NMLS ID 2113062',
    copyright: `Copyright © ${new Date().getFullYear()} Interest Mortgage, All rights reserved. Not available in all states. | `,
  },
  bankrate: {
    title:
      'Bankrate, LLC NMLS ID# 1427381 | NMLS Consumer Access | BR Tech Services, Inc. NMLS ID #1743443 | NMLS Consumer Access',
    copyright: `Copyright © ${new Date().getFullYear()} Bankrate, LLC. A Red Ventures company. All Rights Reserved.`,
  },
  'sage-home-loans': {
    title:
      'Sage Home Loans Corporation NMLS ID# 3304. Not available in all states. |',
    copyright: `Copyright © ${new Date().getFullYear()} Sage Home Loans Corporation, All Rights Reserved.`,
    additionalContent:
      '*Sage Home Loans Corporation NMLS ID # 3304 (Sage Home Loans Corporation (CA) in the state of Georgia; Sage Loans Corporation (CA) in the states of Florida, Nebraska, and Washington).',
  },
}
